import { api } from '@/api/client';
import type { GoogleSetupStatus, VerificationChallenge, WebsiteReport, ReportAI } from './types';
export const reportApi = {
  get: (site: string, audit?: string) => api.get<WebsiteReport>(`/sites/${site}/report`, { audit_id: audit }),
  list: (site: string) => api.get<{audit_id: string; audited_at: string; health_score: number | null; pages_analyzed: number; findings: number}[]>(`/sites/${site}/reports`),
  prepare: (site: string, audit: string) => api.post<ReportAI>(`/sites/${site}/report/analysis?audit_id=${encodeURIComponent(audit)}`),
  pdf: (site: string, audit: string, includeAI = true) => api.blob(`/sites/${site}/report.pdf`, { audit_id: audit, include_ai: includeAI }),
};
export const setupApi = {
  get: (site: string) => api.get<GoogleSetupStatus>(`/sites/${site}/google-setup`),
  challenge: (site: string, method: 'DNS_TXT' | 'META') => api.post<VerificationChallenge>(`/sites/${site}/google-setup/challenge`, { method }),
  verify: (site: string) => api.post<{verified: boolean; property_url: string; integration_id: string; sync_queued: boolean}>(`/sites/${site}/google-setup/verify`),
};
